/*
 * @Author: Json Chen
 * @Date: 2021-07-22 10:58:34
 * @LastEditTime: 2021-08-13 15:40:24
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLogistics/type.ts
 */

export enum LogisticMethod {
  Delivery = 'Delivery',
  ParcelLocker = 'ParcelLocker',
  ClickCollect = 'ClickCollect',
  Digital = 'Digital',
  virtualProductLogisticsMethod = 'virtualProductLogisticsMethod',
}
